import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import * as Solr from "../../3x1010/Solr.js";
import QueryBuilder from "./ctrl/QueryBuilder.js";
import AbstractWidgetToggler from "../../components/common/abstract/AbstractWidgetToggler.js";
import DialogSaveQuery from "../../components/common/DialogSaveQuery.component.js";
import WrapperIO from "./utils/WrapperIO.js";
import DialogLoadQuery from "../../components/common/DialogLoadQuery.component.js";
import ResultViewer from "./results/ResultViewer.js";
//import TreeViewer from "./tree/TreeViewer.js";

export default class PageSolrSimple extends PageCommon {
  constructor() {
    super();
    this.currentQuery = null;
    this.clips = [];
  }

  doSearch(terms, collection, field = null) {
    const rv = new ResultViewer();
    rv.search(terms, collection, field);
  }

  /*  createTree() {
    const tree = new TreeViewer(jQuery(".js-table-tree"), jQuery(".js-tree-data-content"));
    tree.init();
  }*/

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrSimple - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
    // Collezione di default

    //this.initTableTree();
    this.setButtons();
    //this.createTree();
    this.loadQueries();
  }

  initQueryBuilder(query) {
    this.qb = new QueryBuilder(QueryBuilder.QUERY_BIANCA, jQuery(".js-query-chunks"), this.collectionName, query);
    this.qb.init();
  }

  /*initTableTree() {
    const tableTreeCont = new AbstractWidgetToggler({
      btn: document.querySelector(".js-btn-toggle-table"),
      target: document.querySelector(".js-table-tree-cont"),
      activeClass: "is-open",
    });
    tableTreeCont.init();
  }*/

  onTrySearch() {
    const rv = new ResultViewer();
    rv.searchAdvanced(this.qb);
  }

  setButtons() {
    jQuery(".js-try-search").on("click", this.onTrySearch.bind(this));
    jQuery(".js-reset").on("click", this.onReset.bind(this));
    jQuery(".js-svuota").on("click", this.onSvuota.bind(this));
    jQuery(".js-filter-models").on("keydown", this.onFilterModels.bind(this));
  }

  loadQueries() {
    this.showPreloader(true);
    WrapperIO.getQueries(this.wrapperIOHandler.bind(this));
  }

  wrapperIOHandler(e) {
    if (e.type === WrapperIO.EVENT_LOAD_SUCCESS) {
      this.showPreloader(false);
      this.queriesRead = e.queries;
      this.listQueries(e.queries);
    }
  }

  listQueries(queries) {
    jQuery(".js-single-query-to-remove").remove();

    this.clips = [];
    for (let x = 0; x < queries.length; x++) {
      const el = jQuery("#template-single-query").clone();
      el.removeAttr("id");
      el.addClass("js-single-query-to-remove");
      el.text(queries[x].Name);
      jQuery(".js-queries-list").append(el);
      this.clips.push(el);
      el.on("click", this.showQuery.bind(this, x, queries, null));
    }
    this.showQuery(0, queries, null);
  }

  showQuery(index, queries, updatedQuery) {
    // Selezione
    //debugger;

    let q = null;

    if (!updatedQuery) {
      this.clips.forEach((el) => {
        el.removeClass("is-selected");
      });
      this.clips[index].addClass("is-selected");

      const query = JSON.parse(queries[index].Query);
      this.collectionName = query.CollectionName;
      q = Solr.QueryWrapper.fromJsonObject(query);
      this.currentQuery = q;
    } else {
      q = updatedQuery;
    }

    if (this.qb) {
      this.qb.dispose();
    }
    // Qb
    if (!updatedQuery) {
      this.queries = JSON.parse(JSON.stringify(queries));
      this.queriesIndex = index;

      // Info nella pagina
      jQuery(".js-query-name").text(queries[index].Name);
      jQuery(".js-query-collection").text(this.getCollectionNameBello(queries[index].Collection));
    }
    this.initQueryBuilder(q);
  }

  onFilterModels(e) {
    if (this.idto) {
      clearTimeout(this.idto);
    }
    this.idto = setTimeout(this.doFilterModels.bind(this), 200);
  }

  doFilterModels() {
    const value = jQuery(".js-filter-models").val();
    const queries = this.queriesRead.filter((q) => q.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);

    this.listQueries(queries);
  }

  onReset() {
    this.showQuery(this.queriesIndex, this.queries, null);
  }

  onSvuota() {
    this.updateFieldsBasedOnLookup(this.currentQuery);
    this.showQuery(null, null, this.currentQuery);
  }

  updateFieldsBasedOnLookup(data) {
    // Funzione ricorsiva per attraversare tutto l'oggetto
    const traverseAndUpdate = (node) => {
      if (node && typeof node === "object") {
        // Controlla se il nodo ha la proprietà 'Field' e 'Lookup'
        if (node.hasOwnProperty("Field") && node.Field && node.Field.hasOwnProperty("Lookup")) {
          //debugger;
          if (!Pqp.isNullOrEmpty(node.Field.Lookup)) {
            // Se 'Field.Lookup' è valorizzato, setta 'Compare' a 'QueryNodeCompareType.cNOTNULL'
            node.Compare = Solr.QueryNodeCompareType.cNOTNULL;
          } else {
            // Altrimenti setta 'Value' a una stringa vuota
            node.Value = "";
          }
        }

        // Scorre tutte le chiavi del nodo ed eventualmente richiama la funzione ricorsiva
        for (let key in node) {
          if (node.hasOwnProperty(key) && typeof node[key] === "object") {
            traverseAndUpdate(node[key]);
          }
        }
      }

      // Se il nodo è un array, bisogna scorrere tutti i suoi elementi
      if (Array.isArray(node)) {
        node.forEach((item) => traverseAndUpdate(item));
      }
    };

    // Attiva la ricorsione
    traverseAndUpdate(data);
  }
}
